import React from "react";
import FieldPopover from "../../popover/popover";
import FieldDate_Popover from "./components/popover/popover";
import FieldDate_FormValueNotEmpty from "./components/form/value-not-empty";
import FieldConfig from "../../../proto/field-config";
import formatDate from "../../../../gd/format/date";
import FieldDate_View from "./render/view/view";
import FieldDate_ViewSmall from "./render/view/view-small";
import FieldDate_GlistGroupModern from "./components/glist-group/modern";
import FieldDate_ManagementPreview from "./render/management-preview";
import DatetimeUtils from "../../../../gd/utils/datetime-utils";
import {GROUP_DATE_TIME} from "../../../../gd/const/fields/field2-groups";
import FieldDate_InlineValueNotEmpty from "./components/inline-edit/value-not-empty";
import FieldString_ManagementForm from "../../string/render/management-form";
import FieldDate_AutomationActionForm from "./render/automation/automation-action-form";
import FieldDate_AutomationTriggerForm from "./render/automation/automation-trigger-form";
import FieldDate_AutomationConditionForm from "./render/automation/automation-condition-form";
import normalizeDate from "../../../import/normalize/normalize-date";
import ImportFromCSVModule from "../../../../gd-modules/import-from-csv/import-from-csv-module";
import {
    ConditionType_DateRelativeAfter, IConditionType,
} from "../../../../model2/conditions/condition-types";
import FieldDate_ConditionForm from "./render/condition";
import FieldDate_Editable from "./render/editable/editable"
import FieldDate_PickerValueNotEmpty from "./components/picker/value-not-empty"
import FieldDate_GoalListEditable from "./render/goal-list-editable"
import FieldDate_GoalListView from "./render/goal-list-view"
import FieldDate_QuickFilterView from "./render/quick-filter-view"
import {FieldFilterType} from "../../../proto/types"
import {Date_GroupingOptions} from "../../../system/task/date/@const"
import {getIntervalValue} from "../../../../gd/utils/datetime/get-interval-value"
import {getIntervalLabel} from "../../../../gd/utils/datetime/get-interval-label"
import GroupBy from "../../../../gd/manager/group-by/group-by-model"
import {FIELD_CONDITIONS_DATE_WITH_NULL, FieldDate_filterFunc} from "../../../conditions/date"
import ItemModelV2 from "../../../../model2/item2/item-model"
import FieldDate_AggregateCell from "./render/aggregate/aggregate-cell"
import FieldDate_TableCellCalculated from "./render/table/table-cell-calculated"
import {AggregateFunctionType} from "../../../../data-structures/aggregators/types"
import FieldDate_ViewGroup from "./render/group/group"
import FieldDate_BoardAggregate from "./render/aggregate/board-aggregate"

export default class FieldDate extends FieldPopover {

    FIELD_DEFAULT_WIDTH         = 200

    // public minDate?             : Moment
    // public maxDate?             : Moment

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel          = "Date";
        this.filterType         = FieldFilterType.DATE;
        this.typeGroup          = GROUP_DATE_TIME;
        this.typeDescription    = "Generic date picker field";
        this.icon               = _.get(config, 'icon', 'i5-calendar')

        this.minDate            = _.get(config, 'minDate', undefined)       // if set popover calendar disables past minDate
        this.maxDate            = _.get(config, 'maxDate', undefined)       // is set -> disabled future maxDate

        this.isGroupByAvailable         = true
        this.isFilterAvailable          = true

        this.modifierOptions            = Date_GroupingOptions
        this.modifierOptionParamName    = 'interval'

        this.conditionTypes             = FIELD_CONDITIONS_DATE_WITH_NULL

        this.clearButton = _.get(config, 'clearButton', true);

        this.hasCalculatedValues            = true

        this.components.PopoverMenu         = FieldDate_Popover
        this.components.PickerValueNotEmpty = FieldDate_PickerValueNotEmpty
        this.components.FormValueNotEmpty   = FieldDate_FormValueNotEmpty
        this.components.InlineValueNotEmpty = FieldDate_InlineValueNotEmpty
        this.components.ValueIcon           = <span className={Classes("ui5-ico-16 m-r-10 fl-no-shrink", this.icon)}/>
        this.components.glistGroupModern    = FieldDate_GlistGroupModern


        this.renderComponents.view                      = FieldDate_View
        this.renderComponents.viewSmall                 = FieldDate_ViewSmall
        this.renderComponents.managementPreview         = FieldDate_ManagementPreview
        this.renderComponents.managementForm            = FieldString_ManagementForm
        this.renderComponents.automationActionForm      = FieldDate_AutomationActionForm
        this.renderComponents.automationTriggerForm     = FieldDate_AutomationTriggerForm
        this.renderComponents.automationConditionForm   = FieldDate_AutomationConditionForm

        this.renderComponents.conditionForm             = FieldDate_ConditionForm
        this.renderComponents.filterForm                = FieldDate_ConditionForm


        this.renderComponents.editable                  = FieldDate_Editable
        this.renderComponents.goalListEditable          = FieldDate_GoalListEditable
        this.renderComponents.goalListView              = FieldDate_GoalListView

        this.renderComponents.tableCellCalculated       = FieldDate_TableCellCalculated
        this.renderComponents.aggregateCell             = FieldDate_AggregateCell
        this.renderComponents.boardAggregate            = FieldDate_BoardAggregate
        this.renderComponents.viewGroup                 = FieldDate_ViewGroup
        this.renderComponents.quickFilterView           = FieldDate_QuickFilterView

        this.filterFunc                                 = FieldDate_filterFunc
    }

    getDisplayValue(value: any) {
        if (!value) return false
        return formatDate(DatetimeUtils.dateToMoment(value))
    }

    sortValue(value:any, model?: any) {
        return value ? DatetimeUtils.dateToMoment(value).format('x') : ''
    }

    groupValue(value:any, groupBy?:GroupBy) {
        if (!value) return null
        // return formatDate(DatetimeUtils.dateToMoment(value))
        return getIntervalValue(value, groupBy)

        // old
        // return formatDate(DatetimeUtils.dateToMoment(value), 'YYYY-MM-DD')
    }

    groupLabel(value: any, groupBy?:GroupBy): string {
        if (!value || value === 'null') return 'Not set'

        return getIntervalLabel(value, groupBy)
        // return formatDate(DatetimeUtils.dateToMoment(value))
    }

    groupItemValue(itemModel: ItemModelV2, groupBy: GroupBy): any {
        const value = _.get(itemModel.item, this.fieldId, null)
        return this.groupValue(value, groupBy)
    }

    automationGetValuesForDescription(value:any) {
        if (!value) {
            return ['trigger day']
        } else {
            return ['{0} {1} {2} trigger day'.f(Math.abs(value), [-1,1].includes(value) ? 'day' : 'days', value < 0 ? 'before' : 'after')]
        }
    }

    normalizeToCSVValue(model: any): any {
        const rawValue = super.normalizeToCSVValue(model)
        const res: string | null = !_.isEmpty(rawValue) ? DatetimeUtils.momentToDate(momentDate(rawValue)) : null
        return !!res ? res : ''
    }

    normalizeFromCSVValue(value: string, module: ImportFromCSVModule): any {
        return normalizeDate(value)
    }

    get isDateField():boolean {
        return true
    }

    get defaultConditionType(): IConditionType | undefined {
        return ConditionType_DateRelativeAfter
    }

    /** AGGREGATE **/
    getAggregateOptions(): any {
        return [
            AggregateFunctionType.DATE_MIN,
            AggregateFunctionType.DATE_MAX,
            AggregateFunctionType.DATE_RANGE,
        ]
    }
}

